module.exports = __webpack_public_path__ + "028cb14608b66efc28d4842408503953.svg";